export const mdl22Urls = {
  priceListUrl: 'mdl22/products/customerexistinpriceList/',
  finalPriceUrl: 'mdl22/products/getFinalprice',
  fullfillmentPlanUrl: 'mdl22/products/fulfillmentPlan',
  productsPricesURL: 'mdl22/products/productpriceinventory',
  searchListURL: 'mdl22/products/productCustomList/search',
  createNewListURL:
    'mdl22/products/productCustomList/addUpdateproductCustomList',
  fetchLinkedProductVariants: '/mdl22/variants/linkproductvariant/search',
}
